export default "__VITE_ASSET__CgnEnXje__"